import { NetworkConfigType } from '../types';
// ABI
import ERC20TOKENABI from './contracts/testnet/ERC20.json';
import KOLReferral from './contracts/testnet/KOLReferral.json';
import TokenXABI from './contracts/testnet/TokenXBal.json';
import TokenStakeManagerABI from './contracts/testnet/TokenXInteractionPool.json';

const providerKey = process.env.NEXT_PUBLIC_ALCHEMY_KEY || '';

export const TestNetConfig: NetworkConfigType = {
  chainId: '0x61',
  supportedChainIDs: [97],
  providerKey,
  chainName: 'Smart Chain - Testnet',
  nativeCurrency: {
    name: 'Binance',
    symbol: 'BNB',
    xsymbol: 'BNBx',
    decimals: 18,
  },
  rpcUrls: {
    default: `https://bsc-testnet.nodereal.io/v1`,
  },
  blockExplorerUrls: ['https://testnet.bscscan.com'],
  contractAddresses: {
    erc20: '0xae13d989dac2f0debff460ac112a837c89baa7cd',
    xtoken: {
      token: '0x4e16D7Bb32a44e9D43053C86617fbc63223A226C',
      stakingContract: '0x2f9b0eb7e7f5978C3cbe68ef897b15de15408fde',
    },
    referral: '0x50C15cb832dcBFB9ee4b95d101608b664F06D7f7',
  },
  abis: {
    erc20: ERC20TOKENABI,
    xtoken: {
      token: TokenXABI,
      stakingContract: TokenStakeManagerABI,
    },
    referral: KOLReferral,
  },
};
